<template>
	<div>
		<h2>Reenter Room</h2>
		<div>
			<a
				v-for="(room, id) in rooms"
				:key="id"
				:href="'/room/' + room.id"
				class="block"
			>
				{{ room.title }}
			</a>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState({
			rooms: state => state.room.all_rooms,
		}),
	},
	created() {
		this.$store.dispatch('get_user_rooms');
	},
};
</script>
